const predefineColors = [
  '#FFFF00',
  '#FFFFFF',
  '#FF0000',
  '#00FF00',
  '#0000FF',
  '#000000',
  '#FF00FF',
  '#00FFFF',
  '#E7E6E6',
  '#44546A',
  '#4472C4',
  '#ED7D31',
  '#A5A5A5',
  '#FFC000',
  '#5B9BD5',
  '#70AD49'
];

export default predefineColors;